import { useEffect, useRef } from "react";

const bare = (s) => String(s || "").replace(/\D/g, "").replace(/^0+/, "");
const typing = (el) => !!el && (el.isContentEditable || ["INPUT", "TEXTAREA", "SELECT"].includes(el.tagName));

export const isCode = (c) => /^\d{4,20}$/.test(String(c || "").trim());

export function findByCode(items, code) {
  const c = String(code || "").trim();
  if (!c) return null;
  const b = bare(c);
  return items.find((p) => p.barcode && p.barcode === c) || (b && items.find((p) => p.barcode && bare(p.barcode) === b)) || null;
}

export const DEFAULT_SCALE = { code_len: 5, value: "price", width: 60, height: 40 };
export const scaleCfg = (settings) => ({ ...DEFAULT_SCALE, ...(settings?.scale_label || {}) });
const ean13 = (d12) => String((10 - ([...d12].reduce((a, c, i) => a + Number(c) * (i % 2 ? 3 : 1), 0) % 10)) % 10);
const valueLen = (L) => (L === 6 ? 5 : 6);

// Etiqueta de balança: 2 + código do produto + valor (centavos ou gramas) + dígito verificador.
export function encodeScale(plu, value, cfg) {
  const L = cfg.code_len;
  const code = String(Number(plu)).padStart(L, "0");
  const v = String(Math.round(value)).padStart(valueLen(L), "0");
  if (code.length > L || v.length > valueLen(L)) return null;
  const d12 = `2${code}${L === 4 ? "0" : ""}${v}`;
  return d12 + ean13(d12);
}

export function parseScale(code, cfg) {
  const d = String(code || "").trim();
  if (!/^2\d{12}$/.test(d) || ean13(d.slice(0, 12)) !== d[12]) return null;
  const L = cfg.code_len;
  return { plu: Number(d.slice(1, 1 + L)), value: Number(d.slice(Math.max(1 + L, 6), 12)) };
}

export function resolveCode(products, code, cfg) {
  const p = findByCode(products, code);
  if (p) return { product: p };
  const sc = parseScale(code, cfg);
  if (!sc) return null;
  const hit = products.find((x) => x.scale_code && Number(x.scale_code) === sc.plu);
  const qty = !hit ? 0 : cfg.value === "weight" ? sc.value / 1000 : Number(hit.price) > 0 ? sc.value / 100 / Number(hit.price) : 0;
  return qty > 0 ? { product: hit, qty: Math.round(qty * 1000) / 1000 } : { missing: sc.plu };
}

// Leitor USB/Bluetooth digita rápido e termina com Enter; captura fora de campos de texto.
export function useScanner(onCode, scope, enabled = true) {
  const cb = useRef(onCode);
  useEffect(() => { cb.current = onCode; });
  useEffect(() => {
    if (!enabled) return undefined;
    let buf = "";
    let last = 0;
    const onKey = (e) => {
      const dialogs = document.querySelectorAll('[role="dialog"]');
      const top = dialogs[dialogs.length - 1];
      if (typing(document.activeElement) || (scope && !scope.current) || (top && !(scope?.current && top.contains(scope.current)))) { buf = ""; return; }
      const now = Date.now();
      if (now - last > 60) buf = "";
      last = now;
      if (e.key === "Enter") {
        if (buf.length >= 3) { e.preventDefault(); cb.current(buf); }
        buf = "";
      } else if (/^\d$/.test(e.key)) buf += e.key;
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [enabled, scope]);
}
